import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    Button,
    Form,
    Modal,
} from 'react-bootstrap';
import { downloadFile } from '../../helpers/apiHandler';
import { GreenIconSVG } from '../SVG/GreenIconSVG';
import CloseIcon from '../SVG/CloseIcon';
import { reloadContactList } from '../../store/actions/reduxAction';

const ContactExport = (props) => {
    const { contactData, openModalEdit, setOpenModalEdit, selectedContactList, access_token } = props;

    const [contactListName, setContactListName] = useState("");

    useEffect(() => {
        if (openModalEdit === true) {
            setContactListName(selectedContactList.name)
        }
    }, [openModalEdit]);

    const handleSave = () => {
        var url = '/v2/contacts-export-contact-list';

        downloadFile({
            url: url,
            data: {
                name: selectedContactList.name,
                lead_list_id: selectedContactList.id,
                tags: selectedContactList?.tags,
                contact_data: contactData
            },
            access_token: access_token,
            fileName: `${selectedContactList.name}.csv`,
        });
        handleCloseModal();
    };


    const handleCloseModal = () => {
        setOpenModalEdit(false);
        // Reset form fields
        setContactListName('');
    }

    return (
        <>
            <Modal
                show={openModalEdit}
                animation={true}
                onHide={handleCloseModal}
                className="modal-form-contact"
                centered
            >
                <Modal.Body>
                    <CloseIcon handleModalClose={handleCloseModal} />
                    <GreenIconSVG />
                    <Modal.Title as="h4" style={{ margin: '8px 0 16px' }}>
                        Export "{contactListName}"
                    </Modal.Title>
                    <p>Exports the entire contact list</p>

                    <div>{selectedContactList.count} Contact(s)</div>
                    <br></br>
                    <Form>
                        <Form.Group>
                            <Button variant="primary" style={{ minWidth: 160 }} onClick={handleSave}>
                                Export
                            </Button>
                        </Form.Group>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

const mapStateToProps = state => {
    const { access_token, user } = state.auth;

    return {
        access_token,
        user
    };
};

const mapDispatchToProps = dispatch => ({
    reloadContactList: () => dispatch(reloadContactList())
});


export default connect(mapStateToProps, mapDispatchToProps)(ContactExport);
